import { appConfig } from "../app-config.ts"

export const HeaderLogo = () => (
  <img
    style={{ width: `${appConfig.assets.images.logo.width * 2}px` }}
    className="mt-6 mx-auto"
    src={appConfig.assets.images.logo.url}
    alt={`${appConfig.artist.name} logo`}
  />
)
